import { toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';
import { useEditBankAccountNameMutation } from '../../../Store/bankaccount';
import { currentBankAccountSelector } from '../../../Store/paramsBagSlice';
import { SubmitHandler, UseFormRegister } from 'react-hook-form';
import { BankAccount } from '../../../Model/BankAccount';

export const useBankAccountEdit = (register: UseFormRegister<Pick<BankAccount, 'displayName'>>, reset: () => void) => {
  const dispatch = useAppDispatch();
  const currentBankAccount = useAppSelector(currentBankAccountSelector);
  const [editBankAccountName, { isLoading: inProgress }] = useEditBankAccountNameMutation();

  const onSubmit: SubmitHandler<Pick<BankAccount, 'displayName'>> = async (data) => {
    try {
      await editBankAccountName({
        accountNr: currentBankAccount?.accountNr,
        originate: currentBankAccount?.originate,
        displayName: data.displayName,
      });
      reset();
    } catch (e) {
      // TODO
    } finally {
      dispatch(toggleModal());
    }
  };

  const onClose = () => {
    dispatch(toggleModal());
  };

  const getTitle = () => {
    if (currentBankAccount?.displayName) {
      return currentBankAccount.displayName;
    }

    return currentBankAccount?.bankName
      ? currentBankAccount?.accountNr + ` (${currentBankAccount?.bankName})`
      : currentBankAccount?.accountNr;
  };

  return { onSubmit, onClose, inProgress, bankName: getTitle() };
};
